import UserBadge from "@/components/UserBadge";

/**
 * Back-compat wrapper. Older code passes `size` / `variant`. Behavior now
 * matches UserBadge: click to open a describing popover, no browser tooltip.
 */
export default function VerifiedBadge({ size = 14, className = "", variant = "blue", user }) {
  if (user) return <UserBadge user={user} size={size} className={className} />;
  const pseudo = variant === "gold" ? { role: "admin" } : { verified: true };
  return <UserBadge user={pseudo} size={size} className={className} />;
}
